import { render, staticRenderFns } from "./QuickShip.vue?vue&type=template&id=7c1eb972&"
import script from "./QuickShip.vue?vue&type=script&lang=js&"
export * from "./QuickShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports